import { useState, useEffect, useContext } from "react";
import Layout from "../../components/Layout/Layout";
import { IAlert } from "../../helpers/Interfaces";
import MuiAlert from "../../components/Alert/Alert";
import { useNavigate } from "react-router-dom";
import { isInRole } from "../../helpers/HelperFunctions";
import Tabs from "../../components/Tabs/Tabs";
import { User } from "../../store/Store";
import Reports from "./Reports";
import Users from "./Users";

import "./Search.scss";

export default function Search() {

    const [selectedTab, setSelectedTab] = useState(0);

    const [user] = useContext(User);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isInRole(user?.roles, "Admin")) {
            return navigate("/dashboard/reports");
        }
    }, [user])

    return (<Layout selectedIndex={9}>
        <div className="search-container">
            <div className="top-bar">
                <span className="text">Search</span>
            </div>
            <div className="tabs">
                <Tabs titles={["Reports", "Users"]} selectedIndex={selectedTab} onClick={setSelectedTab} />
            </div>
            {selectedTab === 0
                ? (<Reports />)
                : (<></>)
            }
            {selectedTab === 1
                ? (<Users />)
                : (<></>)
            }
        </div>
    </Layout>)
}